import { RiveAnimation } from "@/libraries/wpl/foundations/src/rive-animation";

export const AnimationWithSize = ({ src }: { src: string }) => (
    <RiveAnimation src={src} height="350px" width="600px" />
);
